import SteamTagsSelector from './SteamTagsSelector';
import './index.scss';
export default SteamTagsSelector;
